import { BrowserModule } from "@angular/platform-browser";

import { NgModule, LOCALE_ID } from "@angular/core";

import { registerLocaleData } from "@angular/common";
import localeNl from "@angular/common/locales/nl";
import localeDe from "@angular/common/locales/de";
import localeFr from "@angular/common/locales/fr";
import localeAu from "@angular/common/locales/en-AU";
import localeDECH from "@angular/common/locales/de-CH";
import localeFRCH from "@angular/common/locales/fr-CH";
import localeES from "@angular/common/locales/es";

registerLocaleData(localeNl, "nl");
registerLocaleData(localeDe, "de");
registerLocaleData(localeFr, "fr");
registerLocaleData(localeAu, "en-AU");
registerLocaleData(localeDECH, "de-CH");
registerLocaleData(localeFRCH, "de-FR");
registerLocaleData(localeES, "es");

import { FormsModule } from "@angular/forms";
import { HttpModule, JsonpModule } from "@angular/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { AnimateInModule } from 'ngx-animate-in';

import { HttpClientModule, HttpClient } from "@angular/common/http";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

import { TranslateModule, TranslateLoader } from "@ngx-translate/core";

import { NgModelChangeDebouncedDirective } from './directives/ng-model-change-debounced.directive';

// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToasterModule, ToasterService } from "angular2-toaster";

import { RoutingModule } from "./routing/routing.module";
import { AppComponent } from "./app.component";
import { DataService } from "./data.service";
import { NavigationBarComponent } from "./navigation-bar/navigation-bar.component";
import { FooterBarComponent } from "./footer-bar/footer-bar.component";
import { ShopComponent } from "./shop/shop.component";
import { ProductlistComponent } from "./productlist/productlist.component";
import { WelcomeBarComponent } from "./components/welcome-bar/welcome-bar.component";
import { LoaderComponent } from "./components/loader/loader.component";
import { ContentBlockComponent } from "./components/content-block/content-block.component";

// import { ZXingScannerModule } from '@zxing/ngx-scanner';
// import { OnlineStatusModule } from 'ngx-online-status';

import { PartnershipPipe } from "./partnership.pipe";
import { LoginPageComponent } from "./pages/login-page/login-page.component";
import { ZoomPageComponent } from "./pages/zoom-page/zoom-page.component";
import { ShopPageComponent } from "./pages/shop-page/shop-page.component";
import { AnonShopPageComponent } from "./pages/anon-shop-page/anon-shop-page.component";
import { SuperShopPageComponent } from "./pages/super-shop-page/super-shop-page.component";
import { DentalExpoPageComponent } from "./pages/dentalexpo-page/dentalexpo-page.component";

import { PopupComponent } from "./components/popup/popup.component";
import { LoginUserComponent } from "./components/login-user/login-user.component";
import { ResetPasswordComponent } from "./components/reset-password/reset-password.component";
import { LoginMainAccountForm } from "./components/account-management/account-main-login-form/account-main-login-form.component";
import { AccountPageComponent } from "./pages/account-page/account-page.component";
import { OrderPageComponent } from "./pages/order-page/order-page.component";
import { ShoppingCartComponent } from "./components/shopping-cart/shopping-cart.component";
import { AccountImageUploadComponent } from "./components/account-management/account-image-upload/account-image-upload.component";
import { AccountGeneralInfoComponent } from "./components/account-management/account-general-info/account-general-info.component";
import { AccountCreateComponent } from "./components/account-management/account-create/account-create.component";
import { AccountRequestPageComponent } from "./pages/account-request-page/account-request-page.component";
import { AccountMeetingListComponent } from "./components/account-management/account-meeting-list/account-meeting-list.component";

import { AccountCreatePageComponent } from "./pages/account-create-page/account-create-page.component";
import { CreateAccountPageComponent } from "./pages/create-account-page/create-account-page.component";

import { ProductComponent } from "./components/product/product.component";
import { FilterBarComponent } from "./components/filter-bar/filter-bar.component";
import { VerifyComponent } from "./components/account-management/verify/verify.component";
import { ButtonComponent } from "./components/button/button.component";
import { OrderSuccesguideComponent } from "./components/zoom/order-succesguide/order-succesguide.component";
import { ProductPreviewComponent } from "./components/product/product-preview/product-preview.component";
import { ProductCounterComponent } from "./components/product/product-counter/product-counter.component";
import { HomePageComponent } from "./pages/home-page/home-page.component";
import { AssetsPageComponent } from "./pages/assets-page/assets-page.component";
import { VoucherPageComponent } from "./pages/voucher-page/voucher-page.component";
import { OrderVouchersComponent } from "./components/vouchers/order-vouchers/order-vouchers.component";
import { FtuComponent } from "./components/ftu/ftu.component";
import { ZoomAfspraakPageComponent } from "./pages/zoom-afspraakpage/zoom-afspraakpage.component";
import { AfspraakPageComponent } from "./pages/afspraakpage/afspraakpage.component";

import { ProtectiveCleanPageComponent } from "./pages/protective-clean-page/protective-clean-page.component";
import { AdminComponent } from "./components/admin/admin.component";
import { InstructionsPageComponent } from "./pages/instructions-page/instructions-page.component";
import { IdsPageComponent } from "./pages/ids-page/ids-page.component";
import { ScannerComponent } from "./components/scanner/scanner.component";
import { OrthokitPageComponent } from "./pages/orthokit-page/orthokit-page.component";
import { PinPageComponent } from "./pages/pin-page/pin-page.component";
import { IndexeddbpageComponent } from "./pages/indexeddbpage/indexeddbpage.component";
import { ExpertCleanPageComponent } from "./pages/expert-cleanpage/expert-cleanpage.component";
import { OrangeSphereComponent } from "./components/philips-marks/orange-sphere/orange-sphere.component";
import { JcdPageComponent } from "./pages/jcd-page/jcd-page.component";
import { environment } from "../environments/environment";
import { ExcentPageComponent } from "./pages/excent-page/excent-page.component";
import { AssetComponent } from "./components/asset-library/asset/asset.component";
import { ItemOverviewComponent } from "./components/item-overview/item-overview.component";
import { SearchbarComponent } from "./components/searchbar/searchbar.component";
import { PreviewOrPrintComponent } from "./components/asset-library/preview-or-print/preview-or-print.component";
import { ContentPageComponent } from "./pages/content-page/content-page.component";
import { RequestFormComponent } from "./components/request-form/request-form.component";
import { MeetingPageComponent } from "./components/meeting-page/meeting-page.component";
import { TawkToComponent } from './components/tawk-to/tawk-to.component';
import { HomePageNewComponent } from './pages/home-page-new/home-page-new.component';
import { PoetsplanKindComponent } from './pages/poetsplan-kind/poetsplan-kind.component';
import { InstructieComponent } from './pages/instructie/instructie.component';
import { ZoomComponent } from './pages/zoom/zoom.component';
import { ExcentComponent } from './pages/excent/excent.component';
import { TandenborstelsPageComponent } from './pages/tandenborstels-page/tandenborstels-page.component';
import { OpzetborstelsPageComponent } from './pages/opzetborstels-page/opzetborstels-page.component';
import { FooterDeComponent } from './footer-de/footer-de.component';
import { FooterChComponent } from './footer-ch/footer-ch.component';

var DEFAULT_LOCALE = "nl-NL";

if (
  !!window.location &&
  window.location.hostname.indexOf("philips.com.au") > -1
) {
  DEFAULT_LOCALE = "en-AU";
} else {
  if (
    !!window.location &&
    window.location.hostname.indexOf("dentalshop-au") > -1
  ) {
    DEFAULT_LOCALE = "en-AU";
  } else {
    if (
      !!window.location &&
      window.location.hostname.indexOf("philips.de") > -1
    ) {
      DEFAULT_LOCALE = "de-DE";
    } else {
      if (
        !!window.location &&
        window.location.hostname.indexOf("dentalshop-de.") > -1
      ) {
        DEFAULT_LOCALE = "de-DE";
      } else {
        if (
          !!window.location &&
          window.location.hostname.indexOf("philips.ch") > -1
        ) {
          DEFAULT_LOCALE = "de-CH";
        }
        if (
          !!window.location &&
          window.location.hostname.indexOf("philips.es") > -1
        ) {
          DEFAULT_LOCALE = "es";
        }
      }
    }
  }
}

try {
  const MAIN_COUNTRY = environment["main_country"];
  try {
    const MAIN_LANG = environment["current_language"];
    DEFAULT_LOCALE = `${MAIN_LANG}-${MAIN_COUNTRY}`;
  } catch (e) {
    console.warn("please set 'current_language' in env");
  }
} catch (e) {
  console.warn("please set 'main_country' in env");
}

console.log("we have DEFAULT_LOCALE = ", DEFAULT_LOCALE);

var I18N_BASE = "./assets/i18n/";
var I18N_SUFFIX = ".json";
var NS = "";
var API_BASE = "";

try {
  API_BASE = environment["BASE_URL"];
  NS = environment["NAMESPACE"];

  if (
    !!window.location &&
    !!window.location.hostname &&
    (window.location.hostname.startsWith("dev") ||
      window.location.hostname == "localhost")
  ) {
    if (window.location.port == "4300" || window.location.search == "?local") {
      NS = environment["LOCAL_NAMESPACE"];
      API_BASE = environment["LOCAL_BASE_URL"];
    } else {
      NS = environment["DEV_NAMESPACE"];
      API_BASE = environment["DEV_BASE_URL"];
    }
  }
  I18N_BASE = `${API_BASE}/api/${NS}/translation/`;
  I18N_SUFFIX = "";
} catch (e) {
  console.warn("please set 'BASE_URL' and 'NAMESPACE' in env");
}

console.log("we have I18N_BASE: ", I18N_BASE);
console.log("we have I18N_SUFFIX: ", I18N_SUFFIX);

export function httpLoaderFactory(httpClient: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(httpClient, I18N_BASE, I18N_SUFFIX);
}

@NgModule({
  declarations: [
    AppComponent,
    NgModelChangeDebouncedDirective,
    NavigationBarComponent,
    FooterBarComponent,
    ShopComponent,
    ProductlistComponent,
    WelcomeBarComponent,
    LoaderComponent,
    PartnershipPipe,
    ZoomPageComponent,
    ShopPageComponent,
    AnonShopPageComponent,
    SuperShopPageComponent,
    LoginPageComponent,
    PopupComponent,
    LoginUserComponent,
    ResetPasswordComponent,
    LoginMainAccountForm,
    AccountPageComponent,
    OrderPageComponent,
    ShoppingCartComponent,
    AccountImageUploadComponent,
    AccountGeneralInfoComponent,
    AccountCreateComponent,
    AccountMeetingListComponent,
    AccountRequestPageComponent,
    AccountCreatePageComponent,
    CreateAccountPageComponent,
    ProductComponent,
    FilterBarComponent,
    VerifyComponent,
    ButtonComponent,
    OrderSuccesguideComponent,
    ProductPreviewComponent,
    ProductCounterComponent,
    AssetsPageComponent,
    HomePageComponent,
    VoucherPageComponent,
    OrderVouchersComponent,
    FtuComponent,
    ZoomAfspraakPageComponent,
    AfspraakPageComponent,
    DentalExpoPageComponent, 
    ProtectiveCleanPageComponent,
    AdminComponent,
    InstructionsPageComponent,
    IdsPageComponent,
    ScannerComponent,
    OrthokitPageComponent,
    PinPageComponent,
    IndexeddbpageComponent,
    ExpertCleanPageComponent,
    ContentBlockComponent,
    OrangeSphereComponent,
    JcdPageComponent,
    ExcentPageComponent,
    AssetComponent,
    ItemOverviewComponent,
    SearchbarComponent,
    PreviewOrPrintComponent,
    ContentPageComponent,
    RequestFormComponent,
    MeetingPageComponent,
    TawkToComponent,
    HomePageNewComponent,
    PoetsplanKindComponent,
    InstructieComponent,
    ZoomComponent,
    ExcentComponent,
    TandenborstelsPageComponent,
    OpzetborstelsPageComponent,
    FooterDeComponent,
    FooterChComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    RoutingModule,
    HttpModule,
    JsonpModule,
    BrowserAnimationsModule,
    AnimateInModule,
    HttpClientModule,
    ToasterModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    DataService,
    ToasterService,
    { provide: LOCALE_ID, useValue: DEFAULT_LOCALE },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/app.module.ts